import { render } from "./NewProducts.vue?vue&type=template&id=714ca288&scoped=true"
import script from "./NewProducts.vue?vue&type=script&lang=js"
export * from "./NewProducts.vue?vue&type=script&lang=js"

import "./NewProducts.vue?vue&type=style&index=0&id=714ca288&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714ca288"]])

export default __exports__